/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import isNil from 'lodash.isnil';

// Capitalizes the first letter of the sensor string
export const capitalizeSensor = (str: string) => {
  if (!isNil(str)) {
    return str?.charAt?.(0).toUpperCase() + str?.slice(1);
  }
  return str;
};

// Populates the dropdown options with the sensor data and prepends the sensor number
export const populateDropdownOptions = function(data) {
  if (data && Array.isArray(data)) {
    return data.map?.((sensor: {id: string}, index: number) => ({
      value : sensor?.id,
      label : `Sensor ${index + 1} - ${capitalizeSensor(sensor?.id)}`
    }));
  }
  return [];
};
